<template>
  <a-modal :centered="true" v-model="visible" :title="record.adminId ? '编辑管理员' : '新增管理员'" width="45%" @ok="addAdmin" @cancel="close" :closable="false" :confirm-loading="loading">
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <a-form-item label="手机号">
        <div>
          <a-input
            placeholder="请输入"
            :maxLength="11"
            @change="validPhone"
            v-decorator="[
              'mobile',
              {
                rules: [{ required: true, message: '请输入电话号码' }, { validator: validatorPhone }],
                validateFirst: true,
              },
            ]"
          ></a-input>
          <div style="color: red; font-size: 12px">{{ errMsg }}</div>
        </div>
      </a-form-item>
      <a-form-item label="姓名">
        <a-input placeholder="请输入" :maxLength="30" :disabled="formDisabled" v-decorator="['name', { rules: [{ required: true, message: '请输入姓名' }] }]"></a-input>
      </a-form-item>
      <a-form-item label="性别">
        <a-radio-group
          name="radioGroup"
          :disabled="formDisabled"
          :default-value="1"
          v-decorator="['gender', { initialValue: 1, rules: [{ required: true, message: '请选择性别' }], validateFirst: true }]"
        >
          <a-radio :value="1"> 男 </a-radio>
          <a-radio :value="2"> 女 </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="状态">
        <a-radio-group
          name="radioGroup"
          :disabled="formDisabled || isToc"
          :default-value="true"
          v-decorator="['enabled', { initialValue: true, rules: [{ required: true, message: '请选择状态' }], validateFirst: true }]"
        >
          <a-radio :value="true"> 启用 </a-radio>
          <a-radio :value="false"> 禁用 </a-radio>
        </a-radio-group>
      </a-form-item>
    </a-form>
    <template slot="footer">
      <div class="modal-footer">
        <a-button :disabled="loading" @click="close">取消</a-button>
        <a-button :loading="loading" :disabled="disabledSubmit" type="primary" @click="submit">保存</a-button>
      </div>
    </template>
  </a-modal>
</template>
<script>
import { validPhone as validatorPhone } from '@/utils/valid'
export default {
  name: 'AddAdminModal',
  props: {
    orgId: [Number, String],
    isToc: Boolean,
  },
  data() {
    return {
      visible: false,
      adminId: null,
      record: {},
      loading: false,
      form: this.$form.createForm(this, { name: 'coordinated' }),
      formDisabled: false,
      errMsg: '',
      disabledSubmit: false,
      validatorPhone: validatorPhone,
    }
  },
  methods: {
    show(record = {}) {
      return new Promise((resolve, resject) => {
        this._initPhone = record.mobile
        this.visible = true
        this._res = resolve
        this._rej = resject
        this.record = record
        this.$nextTick(() => {
          this.form.setFieldsValue(record)
        })
      })
    },
    addAdmin() {},
    close() {
      this.visible = false
      this.form.resetFields()
      this.errMsg = ''
      this.disabledSubmit = false
      this.formDisabled = false
      this._initPhone = null
      this.record = {}
    },
    submit() {
      this.form.validateFields(['mobile', 'name', 'gender', 'enabled'], { first: true }, async (err, values) => {
        if (!err) {
          this.loading = true
          const params = {
            organizationId: this.orgId,
            ...values,
          }
          if (this.record._edit || this.record.adminId) {
            params.id = this.record.adminId
          }
          const { data } = await this.$http.Mechanism.AddOrganizationSuperAdmin(params).finally(() => (this.loading = false))
          this.loading = false
          this.$message.success('操作成功')
          this.close()
          this._res(data)
        }
      })
    },
    async updateSubmit(params) {
      const { data } = await this.$http.Mechanism.updateInfo(params).finally(() => (this.loading = false))
      this.loading = false
      this.close()
      this._res(data)
      this.$message.success('操作成功')
    },
    async validPhone(e) {
      const mobile = e.target.value
      this.disabledSubmit = true
      if (String(mobile).length != 11) {
        this.formDisabled = true
        this.errMsg = null
        return
      }
      this.errMsg = null
      const { data } = await this.$http.Mechanism.VerifyOrganizationAdmin({
        Phone: mobile,
        OrganizationId: this.orgId,
      })
      // if (data.status) {
      const result = data.data || data
      switch (result.code) {
        case 201:
        case 203:
          this.form.setFieldsValue({
            name: '',
            gender: 1,
            enabled: true,
          })
          this.formDisabled = true
          this.errMsg = result.errMessage
          this.disabledSubmit = true
          break
        case 202:
          this.form.setFieldsValue({
            name: result.name,
            gender: result.gender,
          })
          this.adminId = result.id
          if (result.id) {
            this.record.adminId = result.id || undefined
          }
          if (mobile === this._initPhone) {
            this.formDisabled = false
            this.disabledSubmit = false
            this.errMsg = null
          }
          break
        default:
          this.formDisabled = false
          this.errMsg = result.errMessage
          this.disabledSubmit = false
      }
    },
    validInput() {
      this.$nextTick(() => {
        const mobile = this.form.getFieldValue('mobile')
        this.disabledSubmit = true
        if (String(mobile).length == 0 || String(mobile).length < 11) {
          this.errMsg = ''
        }
      })
    },
  },
}
</script>
